import * as actionTypes from '../../actions/actionTypes';

const initialState = {
    socialWorks: [],
    loadingSocialWorks: false,

    researchWorks: [],
    loadingResearchWorks: false,

    isBrsm: undefined,
    loadingIsBrsm: false,

    isProfCom: undefined,
    loadingIsProfCom: false
};

const loadSocialWorks = (state) => {
    return {
        ...state,
        loadingSocialWorks: true
    }
}

const setSocialWorks = (state, action) => {
    let tmp = [...action.socialWorks]
    return {
        ...state,
        socialWorks: tmp,
        loadingSocialWorks: false
    }
};

const loadResearchWorks = (state) => {
    return {
        ...state,
        loadingResearchWorks: true
    }
}

const setResearchWorks = (state, action) => {
    let tmp = [...action.researchWorks]
    return {
        ...state,
        researchWorks: tmp,
        loadingResearchWorks: false
    }
};

const loadIsBrsm = (state) => {
    return {
        ...state,
        loadingIsBrsm: true
    }
}

const setIsBrsm = (state, action) => {
    return {
        ...state,
        isBrsm: action.isBrsm,
        loadingIsBrsm: false
    }
}

const loadIsProfCom = (state) => {
    return {
        ...state,
        loadIsProfCom: true
    }
}

const setIsProfCom = (state, action) => {
    return {
        ...state,
        isProfCom: action.isProfCom,
        loadIsProfCom: false
    }
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.LOAD_SOCIAL_WORKS:
            return loadSocialWorks(state);
        case actionTypes.SET_SOCIAL_WORKS:
            return setSocialWorks(state, action);

        case actionTypes.LOAD_RESEARCH_WORKS:
            return loadResearchWorks(state);
        case actionTypes.SET_RESEARCH_WORKS:
            return setResearchWorks(state, action);

        case actionTypes.LOAD_IS_BRSM:
            return loadIsBrsm(state);
        case actionTypes.SET_IS_BRSM:
            return setIsBrsm(state, action);

        case actionTypes.LOAD_IS_PROF_COM:
            return loadIsProfCom(state);
        case actionTypes.SET_IS_PROF_COM:
            return setIsProfCom(state, action);

        default:
            return state;
    }
};
export default reducer;
